import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./style.scss";
import "swiper/swiper-bundle.css";
import FsLightbox from "fslightbox-react";
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
} from "swiper";
import { urlData, imgUrlData } from "../../urlData";
import useWindowDimensions from "../../useWindowDimensions";
import axios from "axios";
import KitchenModal from "../../componentsnew/KitchenModal/KitchenModal";
import AOS from "aos";
import "aos/dist/aos.css";
// image imports
// ----------banner imports
import leftarrow from "../../images/homepage/leftarrow.png";
import rightarrow from "../../images/homepage/rightarrow.png";
import bannernew1 from "../../images/homepage/bannernew1.jpg";
import bannernew2 from "../../images/homepage/bannernew2.jpg";
import mbbannernew1 from "../../images/homepage/mbbannernew1.jpg";
import mbbannernew2 from "../../images/homepage/mbbannernew2.jpg";

import deskbanner50 from "../../images/homepage/deskbanner50.png";
import mbbanner50 from "../../images/homepage/mbbanner50.png";

// ----------products imports
import title_symbol_white from "../../images/homepage/title_symbol_white.png";
import title_symbol_black from "../../images/homepage/title_symbol_black.png";

//----------kitchen recipes
import kitchen_wood_img from "../../images/homepage/kitchen_wood_img.png";
import kitchen_lemon_img from "../../images/homepage/kitchen_lemon_img.png";
import kitchen_leaf_img from "../../images/homepage/kitchen_leaf_img.png";
import play_btn from "../../images/homepage/play_btn.png";

//----------into laxmi world
import Spinner from "../../images/loader.gif";

//locator imports
import locator_left from "../../images/homepage/locator_left.png";
import locator_right from "../../images/homepage/locator_right.png";
import mblocator_top from "../../images/homepage/mblocator_top.png";
import mblocator_bottom from "../../images/homepage/mblocator_bottom.png";
import search_icon from "../../images/homepage/search_icon.png";

//blog imports
import BlogCardDesk from "../../componentsnew/BlogCardDesk/BlogCardDesk";
import BlogCardMob from "../../componentsnew/BlogCardMob/BlogCardMob";
import Faqs from "./FAQ";
import MetaDecorator from "../../componentsnew/MetaDecorator/MetaDecorator";
import {
  cricketBanner,
  exploreBanner,
  frozenRangeBannerDesktop,
  frozenRangeBannerMobile,
  mbCricketBanner,
  mbExploreBanner,
} from "../../images";
// end of image imports

import http from "../../helpers/http";
import config from "../../config/config";

Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectFade]);
const body = document.querySelector("body");

const Homepage = (props) => {
  // if toggler is updated when lightbox is closed it will open it
  // if toggler is updated when lightbox is opened it will close it
  const [toggler, setToggler] = useState(false);
  const { width, height } = useWindowDimensions();
  const [bannerDataArr, setBannerDataArr] = useState([]);
  const [ourProductsArr, setOurProductsArr] = useState([]);
  const [recipesArr, setRecipesArr] = useState([]);
  const [laxmiWorldInfo, setLaxmiWorldArr] = useState([]);
  const [blogsArr, setBlogsArr] = useState([]);

  const [ytId, setytId] = useState("");
  const [selectedImg, setSelectedImg] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const [loading, setLoading] = useState(true);

  // store locator states
  const [zipCodeNum, setZipCodeNum] = useState("");
  const [storesDataArr, setStoresDataArr] = useState([]);
  // const [filterStores, setFilterStores] = useState([]);
  const [wrongPinErr, setWrongPinErr] = useState(false);
  const [noDataErr, setNoDataErr] = useState(false);
  // const bannerUrl = new URL(urlData + "/homepage-sliders");
  const banner_image_url = imgUrlData + "uploads/homepageSlider/";
  const azure_object_url = config.azure_object_url;

  //end of store locator states

  // const fetchSliders = async () => {
  //   const datas = await http.get(bannerUrl);
  //   console.log({ datas });
  //   setBannerDataArr(datas?.data);
  //   // setLoading(false);
  // };

  //useEffect for data to come
  useEffect(() => {
    const bannerUrl = new URL(urlData + "/homepage/banners");

    const productsUrl = new URL(urlData + "/homepage/products");
    // const recipesUrl = new URL(urlData + "/homepage/laxmi-kitchens");
    const recipesUrl = new URL(urlData + "/laxmis-kitchen/recipes");
    const blogsUrl = new URL(urlData + "/blogs");
    const laxmiWorldUrl = new URL(urlData + "/homepage/laxmiworld");
    const storesUrl = new URL(urlData + "/store/stores");

    //for stores
    axios({
      method: "get",
      url: storesUrl,
    })
      .then((res) => {
        // console.log("setStoresDataArr", res.data);
        setStoresDataArr(res.data);
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        alert("Something went wrong");
        window.scrollTo(0, 0);
      });

    //for banners
    axios({
      method: "get",
      url: bannerUrl,
    })
      .then((response) => {
        setBannerDataArr(response.data);
        setLoading(false);
        const homepagesec1swiper = new Swiper(".homepagesec1-swiper", {
          slidesPerView: 1,
          autoplay: {
            delay: 5000,
          },
          loop: true,
          spaceBetween: 0,
          navigation: {
            nextEl: ".homepagesec1-swiper .swiper-button-next",
            prevEl: ".homepagesec1-swiper .swiper-button-prev",
          },
        });
        const mbhomepagesec1swiper = new Swiper(".mbhomepagesec1-swiper", {
          slidesPerView: 1,
          autoplay: {
            delay: 5000,
          },
          loop: true,
          spaceBetween: 0,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    // for our products
    axios({
      method: "get",
      url: productsUrl,
    })
      .then((response) => {
        setOurProductsArr(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    //for kitchen recipes
    axios({
      method: "get",
      url: recipesUrl,
    })
      .then((res) => {
        const featuredRecipes = res.data
          .filter(({ checked }) => checked === true)
          .slice(0, 3);

        setRecipesArr(featuredRecipes);
      })
      .catch((error) => {
        console.error(error);
      });
    // for laxmi world
    axios({
      method: "get",
      url: laxmiWorldUrl,
    })
      .then((res) => {
        // console.log("setLaxmiWorldArr", res.data);
        setLaxmiWorldArr(res.data[0]);
      })
      .catch((error) => {
        console.error(error);
      });

    //for blogs
    axios({
      method: "get",
      url: blogsUrl,
    })
      .then((response) => {
        const featuredBlogs = response.data
          .filter(({ checked }) => checked === true)
          .slice(0, 4);

        setBlogsArr(featuredBlogs.reverse());

        var blogsSwiper = new Swiper(".homeblogs .swiper-container", {
          slidesPerView: 1,
          spaceBetween: 10,
          autoplay: {
            delay: 4000,
          },
          pagination: {
            el: ".homeblogs .swiper-pagination",
            clickable: true,
          },
        });
      })
      .catch((error) => {
        console.log("error while fetching homepage blogs", error);
      });
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);
  useEffect(() => {
    document.querySelector(".px-0.MainNavBar.shadow-lg").style.display =
      "block";
    document.querySelector(".CyanBg.MainFooter").style.display = "block";
    if (body) {
      body.style.height = "block";
    }
  }, []);
  // console.log("---==-==-==", blogsArr);
  const bannerList = bannerDataArr?.map((item, i) => (
    <div className="swiper-slide" key={item._id}>
      {item.url ? (
        <a href={item.url} target="_blank" rel="noreferrer">
          <img src={banner_image_url + item?.image} loading="lazy" alt="img" />
        </a>
      ) : (
        <img src={banner_image_url + item?.image} loading="lazy" alt="img" />
      )}
    </div>
  ));
  const mbbannerList = bannerDataArr?.map((item, i) => (
    <div className="swiper-slide" key={item._id}>
      {item.url ? (
        <a href={item.url} target="_blank" rel="noreferrer">
          <img
            src={banner_image_url + item?.mobile_image}
            loading="lazy"
            alt="img"
          />
        </a>
      ) : (
        <img
          src={banner_image_url + item?.mobile_image}
          loading="lazy"
          alt="img"
        />
      )}
    </div>
  ));
  const ourProductsList = ourProductsArr.map((data, i) => (
    <div className="product" key={i}>
      <Link to="/products">
        <img
          src={imgUrlData + data?.desktopImageUrl}
          alt="img"
          className="product_img"
        />
      </Link>
      <div className="product_title">{data.text}</div>
    </div>
  ));
  const recipeClicked = (id, img) => {
    setytId(id);
    setSelectedImg(img);
    setModalShow(true);
  };
  const recipesArrList = recipesArr.map((recipe, i) => (
    <div className="kitchen_recipe" key={i}>
      <img
        src={imgUrlData + recipe?.desktopImageUrl}
        className="recipe_thumbnail"
        alt="img"
        loading="lazy"
      />
      <div className="recipe_details">
        <div className="recipe_title">{recipe.title}</div>
        <div className="recipe_date">{recipe.showDate}</div>
        <img
          src={play_btn}
          alt="play icon"
          className="recipe_play_btn"
          onClick={() =>
            recipeClicked(recipe.videoUrl, recipe?.desktopImageUrl)
          }
        />
      </div>
    </div>
  ));
  const getFullBlogDetail = (blog) => {
    props.history.push(`/blogs/${blog.slug}`);
  };
  const blogDeskCardList = blogsArr
    .slice(0, 4)
    .map((blog, i) => (
      <BlogCardDesk
        imgSrc={blog?.desktopImageUrl}
        blogDate={blog.showDate}
        blogTitle={blog.title}
        blogDesc={blog.synopsis}
        key={i}
        onClick={() => getFullBlogDetail(blog)}
      />
    ));
  const mbBlogCardList = blogsArr.slice(0, 4).map((blog, i) => (
    <div className="swiper-slide">
      <BlogCardMob
        imgSrc={blog.mobileImageUrl}
        blogDate={blog.showDate}
        blogTitle={blog.title}
        blogDesc={blog.synopsis}
        key={i}
        onClick={() => getFullBlogDetail(blog)}
      />
    </div>
  ));

  const handleOnChange = (e) => {
    const re = /^[0-9\b]+$/;

    // if value is not blank, then test the regex

    if (e.target.value === "" || re.test(e.target.value)) {
      setZipCodeNum(e.target.value);
      setWrongPinErr(false);
      setNoDataErr(false);
    }
  };

  const handleFindStoreClick = () => {
    let zipLength = zipCodeNum.length;
    if (zipLength == "" || zipLength < 5 || zipLength > 6 || zipCodeNum < 0) {
      // alert("plzz enter valid zip code");
      setWrongPinErr(true);
      setNoDataErr(false);
    } else {
      const getIndexOfZipCodeForValidation = storesDataArr.findIndex(
        ({ zip }) => zip == zipCodeNum
      );

      if (getIndexOfZipCodeForValidation !== -1) {
        const filterStores = storesDataArr.filter(
          ({ zip }) => zip == zipCodeNum
        );

        props.history.push({
          pathname: "/store-locator",
          state: filterStores,
        });
      } else {
        // alert("no result found");
        setWrongPinErr(false);
        setNoDataErr(true);
      }
    }
  };

  if (loading) {
    <div className="Spinner">
      <img src={Spinner} alt="spinner" />
    </div>;
  }
  return (
    <>
      <MetaDecorator
        metaTitle="50 Years of Laxmi (HOS) - North America's #1 South Asian Food Brand"
        metaDesc="Laxmi, the most loved South Asian food brand in America for 5 decades. The Laxmi Promise is to provide Purity, Quality and Value. Explore Laxmi's endless range of products now!"
        canonicalLink="https://laxmihos.com/"
      />

      <section
        className="homepagesec1"
        data-aos="fade"
        data-aos-delay="100"
        data-aos-duration="1000"
      >
        {width > 1023 ? (
          <>
            <div className="homepagesec1-swiper swiper-container">
              <div className="swiper-wrapper">
                {bannerList}

                {/* <div
                  className="swiper-slide"
                  onClick={() => setToggler(!toggler)}
                >
                  <img src={bannerimgnew} alt="img" loading="lazy"/>
                </div> */}

                {/* <div className="swiper-slide">
                  <a href={diwaliwinner}>
                    <img src={winnerhomepage} alt="banner" loading="lazy" />
                  </a>
                </div> */}
                {/* <div className="swiper-slide">
                  <a href={diwali}>
                    <img src={diwalihomepage} alt="banner" loading="lazy" />
                  </a>
                </div> */}
                {/* <div className="swiper-slide">
                  <a href="/50-years-contest">
                    <img src={contestclosed} alt="banner" loading="lazy" />
                  </a>
                </div> */}
                {/* <div className="swiper-slide">
                  <img src={biggestdhamaka1} alt="banner" loading="lazy" />
                </div> */}
                {/* <div className="swiper-slide">
                  <a href="https://laxmihos.com/50-years-contest">
                    <img src={yearscontestdesk} alt="banner" loading="lazy" />
                  </a>
                </div> */}
                {/* <div className="swiper-slide">
                
                    <img src={ramadanBannerDesktop} alt="banner" loading="lazy" />
                 
                </div> */}
                {/* <div className="swiper-slide">
                  <img src={cricketBanner} alt="banner" loading="lazy" />
                </div>
                <div className="swiper-slide">
                  <img src={exploreBanner} alt="banner" loading="lazy" />
                </div>
                <div className="swiper-slide">
                  <img
                    src={frozenRangeBannerDesktop}
                    alt="banner"
                    loading="lazy"
                  />
                </div>
                <div className="swiper-slide">
                  <img src={deskbanner50} alt="banner" loading="lazy" />
                </div>

                <div className="swiper-slide">
                  <img src={bannernew2} alt="banner" loading="lazy" />
                </div>

                <div className="swiper-slide">
                  <a
                    href="https://www.youtube.com/watch?v=eve5GMV6yKw"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={bannernew1} alt="banner" loading="lazy" />
                  </a>
                </div> */}
              </div>
              <img
                src={rightarrow}
                className="swiper-button-next"
                alt="arrow"
                loading="lazy"
              />
              <img
                src={leftarrow}
                className="swiper-button-prev"
                alt="arrow"
                loading="lazy"
              />
            </div>
          </>
        ) : (
          <div className="mbhomepagesec1-swiper swiper-container">
            <div className="swiper-wrapper">
              {mbbannerList}
              {/* <div
                className="swiper-slide"
                onClick={() => setToggler(!toggler)}
              >
                <img src={mbbannerimgnew} alt="banner" loading="lazy" />
              </div> */}
              {/* <div className="swiper-slide">
                <img src={biggestdhamakamob} alt="banner" loading="lazy" />
              </div> */}
              {/* <div className="swiper-slide">
                <img src={biggestdhamakamob} alt="banner" loading="lazy" />
              </div> */}
              {/* <div className="swiper-slide">
                <a href={diwaliwinner}>
                  <img src={winnerhomepagemob} alt="banner" loading="lazy" />
                </a>
              </div> */}
              {/* <div className="swiper-slide">
                <a href={diwali}>
                  <img src={diwalihomepagemob} alt="banner" loading="lazy" />
                </a>
              </div> */}
              {/* <div className="swiper-slide">
                <a href="/50-years-contest">
                  <img src={contestclosedmob} alt="banner" loading="lazy" />
                </a>
              </div> */}
              {/* <div className="swiper-slide">
                <a href="https://laxmihos.com/50-years-contest">
                  <img src={yearscontestmob} alt="banner" loading="lazy" />
                </a>
              </div> */}

              {/* <div className="swiper-slide">
               
                  <img src={ramadanBannerMobile} alt="banner" loading="lazy" />
               
              </div> */}
              {/* <div className="swiper-slide">
                <img src={mbCricketBanner} alt="banner" loading="lazy" />
              </div>
              <div className="swiper-slide">
                <img src={mbExploreBanner} alt="banner" loading="lazy" />
              </div>
              <div className="swiper-slide">
                <img
                  src={frozenRangeBannerMobile}
                  alt="banner"
                  loading="lazy"
                />
              </div>
              <div className="swiper-slide">
                <img src={mbbanner50} alt="banner" loading="lazy" />
              </div>

              <div className="swiper-slide">
                <img src={mbbannernew2} alt="banner" loading="lazy" />
              </div>
              <div className="swiper-slide">
                <a
                  href="https://www.youtube.com/watch?v=eve5GMV6yKw"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={mbbannernew1} alt="banner" loading="lazy" />
                </a>
              </div> */}
            </div>
          </div>
        )}
      </section>
      <section
        className="my_container"
        data-aos="fade-up"
        // data-aos-delay="1200"
        data-aos-duration="1400"
      >
        <div className="homesec2">
          <div className="text_container">
            <div className="title">Our Products</div>
            <img
              src={title_symbol_black}
              className="title_symbol"
              alt="symbol"
              loading="lazy"
            />
          </div>
          <div className="products_flex">{ourProductsList}</div>
          <div className="btn-wrapper">
            <Link to="/products">
              <button className="btn">VIEW ALL PRODUCTS</button>
            </Link>
          </div>
        </div>
      </section>
      <section
        className="homesec3"
        data-aos="fade-up"
        // data-aos-delay="1200"
        data-aos-duration="1400"
      >
        <div className="title_container">
          <h1 className="title">It is time to bring Laxmi home</h1>
          <img
            src={title_symbol_white}
            className="title_symbol"
            alt="symbol"
            loading="lazy"
          />
          <div className="sub_title">
            Shop exclusive range of Laxmi Products Now!
          </div>
        </div>
        <div className="input_container">
          <input
            type="text"
            className="input_style"
            placeholder="Enter your Zip Code"
            value={zipCodeNum}
            onChange={handleOnChange}
          />
          <button className="search_store_btn" onClick={handleFindStoreClick}>
            <img
              src={search_icon}
              className="search_icon"
              alt="search"
              loading="lazy"
            />
            <span className="search_store_btn_text">FIND A STORE</span>
          </button>
        </div>
        {wrongPinErr ? (
          <div className="wrong_pin">Please enter valid zip code</div>
        ) : null}
        {noDataErr ? <div className="no_result">No result found</div> : null}

        <div className="mb_input_container">
          <div className="mb_input_wrapper">
            <input
              type="text"
              className="mb_input_style"
              placeholder="Enter your Zip Code"
              value={zipCodeNum}
              onChange={handleOnChange}
            />
            {wrongPinErr ? (
              <div className="mb_wrong_pin">Please enter valid zip code</div>
            ) : null}
            {noDataErr ? (
              <div className="mb_no_result">No result found</div>
            ) : null}
          </div>
          <button
            className="mb_search_store_btn"
            onClick={handleFindStoreClick}
          >
            <img
              src={search_icon}
              className="mb_search_icon"
              alt="search"
              loading="lazy"
            />
            <span className="mb_search_store_btn_text">FIND A STORE</span>
          </button>
        </div>

        <img
          src={locator_left}
          className="locator_left"
          alt="locator"
          loading="lazy"
        />
        <img
          src={locator_right}
          className="locator_right"
          alt="locator"
          loading="lazy"
        />

        <img
          src={mblocator_top}
          className="mblocator_top"
          alt="locator"
          loading="lazy"
        />
        <img
          src={mblocator_bottom}
          className="mblocator_bottom"
          alt="locator"
          loading="lazy"
        />
      </section>
      {recipesArr.length > 0 ? (
        <section
          className="homesec4"
          data-aos="fade-up"
          // data-aos-delay="1200"
          data-aos-duration="1400"
        >
          <div className="text_container">
            <div className="title">Laxmi's Recipe's</div>
            <img
              src={title_symbol_black}
              className="title_symbol"
              alt="symbol"
              loading="lazy"
            />
          </div>

          <div className="recipe_wrapper">{recipesArrList}</div>
          <div className="btn-wrapper">
            <Link to="/kitchen">
              <button className="btn">VIEW ALL RECIPES</button>
            </Link>
          </div>

          <KitchenModal
            show={modalShow}
            props={props}
            img={selectedImg}
            youtubevideo={ytId}
            onHide={() => setModalShow(false)}
          />
          <img
            src={kitchen_wood_img}
            className="kitchen_wood_img"
            alt="wood"
            loading="lazy"
          />
          <img
            src={kitchen_lemon_img}
            className="kitchen_lemon_img"
            alt="lemon"
            loading="lazy"
          />
          <img
            src={kitchen_leaf_img}
            className="kitchen_leaf_img"
            alt="leaf"
            loading="lazy"
          />
        </section>
      ) : null}
      {/*      
      {blogsArr.length > 0 ? (
        <section className="homeblogs">
          <div className="text_container">
            <div className="title">BLOGS</div>
            <img src={title_design} className="title_design" 
          alt="img" loading="lazy" />
          </div>
          {width > 767 ? (
            <>
              <div className="blogs_flex">{blogDeskCardList}</div>
            </>
          ) : (
            <>
              <div className="mb_blog_wrapper">
                <div className="swiper-container">
                  <div className="swiper-wrapper">{mbBlogCardList}</div>
                </div>
              </div>
              <div className="swiper-pagination"></div>
            </>
          )}
          <div className="btn-wrapper">
            <Link to="/blogs">
              <button className="btn">VIEW ALL</button>
            </Link>
          </div>
        </section>
      ) : null} */}
      <section className="homesec5">
        {width > 1023 ? (
          <div
            className="flex_wrapper"
            data-aos="fade-up"
            // data-aos-delay="1200"
            data-aos-duration="1400"
          >
            <div className="flex_left">
              <div className="title">About Us</div>
              <img
                src={title_symbol_black}
                className="title_symbol"
                alt="tower img"
                loading="lazy"
              />
              <div className="text_content">
                {laxmiWorldInfo?.description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: laxmiWorldInfo?.description.replace(
                        /(<? *script)/gi,
                        "illegalscript"
                      ),
                    }}
                  ></div>
                ) : (
                  ""
                )}
                {/* Laxmi has become the symbol of authentic quality, ensured by
                each of its 200+ employees across 12 distribution centers
                throughout North America. Renowned for its wide reach and a
                steady supply of great-tasting ethnic foods, Laxmi, from House
                of Spices, is synonymous with delivering products that stand for
                Quality, Purity and Everyday Value to South Asian consumers. The
                brand offers a wide range of authentic South Asian foods in the
                ambient and frozen categories. Today, Laxmi strives to cater to
                the ever-evolving needs of its consumer base by matching
                changing food habits with newly launched value-added product
                ranges. <br /> <br /> Mr. G. L. Soni completely transformed the
                South Asian food experience in North America. His enterprising
                spirit has made it possible for families to enjoy homestyle
                South Asian cooking at all times. The business now operates on
                an international scale. But Laxmi stays grounded in the simple
                pleasures of living- a love of family, the joy of good food and
                the reassurance of familiar flavours. */}
              </div>
              <Link to="/story">
                <button className="btn">KNOW MORE</button>
              </Link>
            </div>
            <div className="flex_right">
              <img
                src={imgUrlData + laxmiWorldInfo?.desktopImageUrl}
                className="aboutrightimg"
                alt="img"
                loading="lazy"
              />
            </div>
          </div>
        ) : (
          <div className="mb_cont">
            <div className="text_container">
              <div className="title">About Us</div>
              <img
                src={title_symbol_black}
                className="title_symbol"
                alt="symbol"
                loading="lazy"
              />
              <img
                src={imgUrlData + laxmiWorldInfo?.desktopImageUrl}
                className="mb_aboutrightimg"
                alt="img"
                loading="lazy"
              />
              <div className="mb_text_content">
                {laxmiWorldInfo?.description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: laxmiWorldInfo?.description.replace(
                        /(<? *script)/gi,
                        "illegalscript"
                      ),
                    }}
                  ></div>
                ) : (
                  ""
                )}
                {/* Laxmi has become the symbol of authentic quality, ensured by
                each of its 200+ employees across 12 distribution centers
                throughout North America. Renowned for its wide reach and a
                steady supply of great-tasting ethnic foods, Laxmi, from House
                of Spices, is synonymous with delivering products that stand for
                Quality, Purity and Everyday Value to South Asian consumers. The
                brand offers a wide range of authentic South Asian foods in the
                ambient and frozen categories. Today, Laxmi strives to cater to
                the ever-evolving needs of its consumer base by matching
                changing food habits with newly launched value-added product
                ranges. <br /> <br /> Mr. G. L. Soni completely transformed the
                South Asian food experience in North America. His enterprising
                spirit has made it possible for families to enjoy homestyle
                South Asian cooking at all times. The business now operates on
                an international scale. But Laxmi stays grounded in the simple
                pleasures of living- a love of family, the joy of good food and
                the reassurance of familiar flavours. */}
              </div>
              <div className="btn-wrapper">
                <Link to="/story">
                  <button className="btn">Know More</button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </section>
      <div data-aos="fade-up" data-aos-duration="1400">
        <Faqs />
      </div>
      <FsLightbox
        toggler={toggler}
        sources={["https://www.youtube.com/embed/vd7CHKdaR6E"]}
      />
    </>
  );
};

export default Homepage;
